module.exports = __webpack_public_path__ + "static/media/barner.9fd58499.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Common/Subscribe/barner.png
 ** module id = 300
 ** module chunks = 0
 **/